import { render } from "./alldoctorchatwithpatientView.vue?vue&type=template&id=7163562f&scoped=true"
import script from "./alldoctorchatwithpatientView.vue?vue&type=script&lang=js"
export * from "./alldoctorchatwithpatientView.vue?vue&type=script&lang=js"

import "./alldoctorchatwithpatientView.vue?vue&type=style&index=0&id=7163562f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7163562f"]])

export default __exports__